import React from 'react'
import { Box } from '@material-ui/core'
import { InfoContainer, InfoContainerProps } from './components'

type PreProposalBadgeProps = InfoContainerProps

export const PreProposalBadge: React.FC<PreProposalBadgeProps> = (props) => {
  const { numberOfInstallments, requestedAmountCents, loanCreatedAt, installmentValue } = props

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      borderRadius: 1
    }}>
      <InfoContainer
        installmentValue={installmentValue}
        numberOfInstallments={numberOfInstallments}
        requestedAmountCents={requestedAmountCents}
        loanCreatedAt={loanCreatedAt}
      />
    </Box>
  )
}
